import { render, staticRenderFns } from "./ContentImage.vue?vue&type=template&id=409efac2&"
import script from "./ContentImage.vue?vue&type=script&lang=js&"
export * from "./ContentImage.vue?vue&type=script&lang=js&"
import style0 from "./ContentImage.vue?vue&type=style&index=0&id=409efac2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
